import { Link } from 'react-router-dom'

import { cn } from '@/lib/cn'

interface AvatarProps {
  src?: string | null
  alt: string
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  to?: string
  className?: string
}

const sizeClass = {
  xs: 'size-8',
  sm: 'size-10',
  md: 'size-12',
  lg: 'size-16',
  xl: 'size-32',
}

// 阶梯角的台阶随尺寸放大，大头像上 2px 的台阶几乎看不出来
const stepClass = {
  xs: '[--px-step:2px]',
  sm: '[--px-step:2px]',
  md: '[--px-step:3px]',
  lg: '[--px-step:4px]',
  xl: '[--px-step:6px]',
}

export function Avatar({ src, alt, size = 'md', to, className }: AvatarProps) {
  const image = src ? (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      className={cn('size-full object-cover px-corners', stepClass[size], 'bg-surface-subtle')}
    />
  ) : (
    <div
      className={cn(
        'flex size-full items-center justify-center px-corners',
        stepClass[size],
        'bg-brand-subtle text-brand-ink font-bold select-none',
      )}
      aria-hidden
    >
      {alt.slice(0, 1).toUpperCase()}
    </div>
  )

  // 阶梯角裁在里层，外层不裁：链接的焦点框要画在外面，裁了就看不见了
  const box = cn('shrink-0', sizeClass[size], className)

  if (to) {
    return (
      <Link to={to} className={box} onClick={(event) => event.stopPropagation()} aria-label={alt}>
        {image}
      </Link>
    )
  }
  return <div className={box}>{image}</div>
}
